(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/hooks/use-needs-unlock.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/hooks/use-needs-unlock.js');
'use strict';

const useNeedsUnlock = exclusions => {
  for (let i = 0; i < exclusions.length; i++) {
    const expiryDate = new Date(exclusions[i].expiry);
    if (dateFns.isAfter(new Date(), expiryDate) || dateFns.isAfter(expiryDate, dateFns.addYears(new Date(), 1))) {
      return true;
    }
  }
  return false;
};
svs.selfExclusion.useNeedsUnlock = useNeedsUnlock;

 })(window);